// extracted by mini-css-extract-plugin
export default {"wrapper":"Group_wrapper__sFTON","active":"Group_active__tsvIq"};